import { render, staticRenderFns } from "./QuestionnaireHistoryPage.vue?vue&type=template&id=7366e478&scoped=true"
import script from "./QuestionnaireHistoryPage.vue?vue&type=script&lang=js"
export * from "./QuestionnaireHistoryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7366e478",
  null
  
)

export default component.exports